"use strict";

var _objectWithoutProperties = require("/opt/build/repo/node_modules/@babel/runtime/helpers/objectWithoutProperties.js");
var _excluded = ["clerk"],
  _excluded2 = ["clerk"],
  _excluded3 = ["clerk"];
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function __export(target, all) {
  for (var name in all) {
    __defProp(target, name, {
      get: all[name],
      enumerable: true
    });
  }
};
var __copyProps = function __copyProps(to, from, except, desc) {
  if (from && typeof from === "object" || typeof from === "function") {
    var _iterator = _createForOfIteratorHelper(__getOwnPropNames(from)),
      _step;
    try {
      var _loop = function _loop() {
        var key = _step.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: function get() {
            return from[key];
          },
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      };
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return to;
};
var __toESM = function __toESM(mod, isNodeMode, target) {
  return target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
    value: mod,
    enumerable: true
  }) : target, mod);
};
var __toCommonJS = function __toCommonJS(mod) {
  return __copyProps(__defProp({}, "__esModule", {
    value: true
  }), mod);
};
var controlComponents_exports = {};
__export(controlComponents_exports, {
  AuthenticateWithRedirectCallback: function AuthenticateWithRedirectCallback() {
    return _AuthenticateWithRedirectCallback;
  },
  ClerkLoaded: function ClerkLoaded() {
    return _ClerkLoaded;
  },
  ClerkLoading: function ClerkLoading() {
    return _ClerkLoading;
  },
  MultisessionAppSupport: function MultisessionAppSupport() {
    return _MultisessionAppSupport;
  },
  RedirectToCreateOrganization: function RedirectToCreateOrganization() {
    return _RedirectToCreateOrganization;
  },
  RedirectToOrganizationProfile: function RedirectToOrganizationProfile() {
    return _RedirectToOrganizationProfile;
  },
  RedirectToSignIn: function RedirectToSignIn() {
    return _RedirectToSignIn;
  },
  RedirectToSignUp: function RedirectToSignUp() {
    return _RedirectToSignUp;
  },
  RedirectToUserProfile: function RedirectToUserProfile() {
    return _RedirectToUserProfile;
  },
  SignedIn: function SignedIn() {
    return _SignedIn;
  },
  SignedOut: function SignedOut() {
    return _SignedOut;
  }
});
module.exports = __toCommonJS(controlComponents_exports);
var import_react = __toESM(require("react"));
var import_AuthContext = require("../contexts/AuthContext");
var import_IsomorphicClerkContext = require("../contexts/IsomorphicClerkContext");
var import_SessionContext = require("../contexts/SessionContext");
var import_StructureContext = require("../contexts/StructureContext");
var import_withClerk = require("./withClerk");
var _SignedIn = function _SignedIn(_ref) {
  var children = _ref.children;
  var _ref2 = (0, import_AuthContext.useAuthContext)(),
    userId = _ref2.userId;
  if (userId) {
    return /* @__PURE__ */import_react.default.createElement(import_react.default.Fragment, null, children);
  }
  return null;
};
var _SignedOut = function _SignedOut(_ref3) {
  var children = _ref3.children;
  var _ref4 = (0, import_AuthContext.useAuthContext)(),
    userId = _ref4.userId;
  if (userId === null) {
    return /* @__PURE__ */import_react.default.createElement(import_react.default.Fragment, null, children);
  }
  return null;
};
var _ClerkLoaded = function _ClerkLoaded(_ref5) {
  var children = _ref5.children;
  var isomorphicClerk = (0, import_IsomorphicClerkContext.useIsomorphicClerkContext)();
  if (!isomorphicClerk.loaded) {
    return null;
  }
  return /* @__PURE__ */import_react.default.createElement(import_StructureContext.LoadedGuarantee, null, children);
};
var _ClerkLoading = function _ClerkLoading(_ref6) {
  var children = _ref6.children;
  var isomorphicClerk = (0, import_IsomorphicClerkContext.useIsomorphicClerkContext)();
  if (isomorphicClerk.loaded) {
    return null;
  }
  return /* @__PURE__ */import_react.default.createElement(import_react.default.Fragment, null, children);
};
var _RedirectToSignIn = (0, import_withClerk.withClerk)(function (_ref7) {
  var clerk = _ref7.clerk,
    props = _objectWithoutProperties(_ref7, _excluded);
  var client = clerk.client,
    session = clerk.session;
  var __unstable__environment = clerk.__unstable__environment;
  var hasActiveSessions = client.activeSessions && client.activeSessions.length > 0;
  import_react.default.useEffect(function () {
    if (session === null && hasActiveSessions && __unstable__environment) {
      var afterSignOutOneUrl = __unstable__environment.displayConfig.afterSignOutOneUrl;
      void clerk.navigate(afterSignOutOneUrl);
    } else {
      void clerk.redirectToSignIn(props);
    }
  }, []);
  return null;
}, "RedirectToSignIn");
var _RedirectToSignUp = (0, import_withClerk.withClerk)(function (_ref8) {
  var clerk = _ref8.clerk,
    props = _objectWithoutProperties(_ref8, _excluded2);
  import_react.default.useEffect(function () {
    void clerk.redirectToSignUp(props);
  }, []);
  return null;
}, "RedirectToSignUp");
var _RedirectToUserProfile = (0, import_withClerk.withClerk)(function (_ref9) {
  var clerk = _ref9.clerk;
  import_react.default.useEffect(function () {
    clerk.redirectToUserProfile();
  }, []);
  return null;
}, "RedirectToUserProfile");
var _RedirectToOrganizationProfile = (0, import_withClerk.withClerk)(function (_ref10) {
  var clerk = _ref10.clerk;
  import_react.default.useEffect(function () {
    clerk.redirectToOrganizationProfile();
  }, []);
  return null;
}, "RedirectToOrganizationProfile");
var _RedirectToCreateOrganization = (0, import_withClerk.withClerk)(function (_ref11) {
  var clerk = _ref11.clerk;
  import_react.default.useEffect(function () {
    clerk.redirectToCreateOrganization();
  }, []);
  return null;
}, "RedirectToCreateOrganization");
var _AuthenticateWithRedirectCallback = (0, import_withClerk.withClerk)(function (_ref12) {
  var clerk = _ref12.clerk,
    handleRedirectCallbackParams = _objectWithoutProperties(_ref12, _excluded3);
  import_react.default.useEffect(function () {
    void clerk.handleRedirectCallback(handleRedirectCallbackParams);
  }, []);
  return null;
}, "AuthenticateWithRedirectCallback");
var _MultisessionAppSupport = function _MultisessionAppSupport(_ref13) {
  var children = _ref13.children;
  var session = (0, import_SessionContext.useSessionContext)();
  return /* @__PURE__ */import_react.default.createElement(import_react.default.Fragment, {
    key: session ? session.id : "no-users"
  }, children);
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  AuthenticateWithRedirectCallback: _AuthenticateWithRedirectCallback,
  ClerkLoaded: _ClerkLoaded,
  ClerkLoading: _ClerkLoading,
  MultisessionAppSupport: _MultisessionAppSupport,
  RedirectToCreateOrganization: _RedirectToCreateOrganization,
  RedirectToOrganizationProfile: _RedirectToOrganizationProfile,
  RedirectToSignIn: _RedirectToSignIn,
  RedirectToSignUp: _RedirectToSignUp,
  RedirectToUserProfile: _RedirectToUserProfile,
  SignedIn: _SignedIn,
  SignedOut: _SignedOut
});